interface errorPageProps {
  statusCode?: number;
  jobLinks?: any;
  socialLinks?: any;
  themeType?: string;
  isDesktopView?: boolean;
  basePathRewrite?: any;
  isCategoriesPage?: boolean;
  jobTitle?: string;
  isSearchPage?: boolean;
}
export default function errorPageProps(props: errorPageProps) {
  const {
    statusCode,
    jobLinks,
    socialLinks,
    themeType,
    isDesktopView,
    basePathRewrite,
    jobTitle,
    isSearchPage,
    isCategoriesPage,
  } = props;
  return {
    statusCode,
    jobLinks,
    socialLinks,
    themeType,
    isDesktopView,
    basePathRewrite,
    jobTitle,
    isSearchPage,
    isCategoriesPage,
  };
}
